<template>
	<div class="">
		<header-vue></header-vue>
		<div class="login login2">
		
		    <div class="log-email">
		    	<h3>
		    		重置密码
		    	</h3>
		    	<p class="log_warn" v-if="ifwarn" v-text="warntxt"></p>
		    	<input placeholder="原密码" type="password" v-model="oldPass" class="log-input log-input-empty" />
		    	<input placeholder="密码" type="password" v-model="newPass" class="log-input log-input-empty" />
		    	<input placeholder="确认密码" type="password" v-model="comfirNewPass" class="log-input log-input-empty" />
		    	
		        <a href="javascript:;" class="log-btn" @click="registerNew()">确定</a>
		    </div>
		    <el-dialog
		      width="30%"
		      class="text-center"
		      @close="closeDialog()"
		      :title="innerUpPassText"
		      :visible.sync="innerUpPass"
		      append-to-body>
		    </el-dialog>
		</div>
	</div>
	
</template>

<script>
	let sha256=require("js-sha256").sha256;
	export default {
		mounted(){
		  	this.$nextTick(function(){
		  		
		  		
		  	})
		},
		data() {
		  	return {
		  		innerUpPassText:"",
		  		innerUpPass:false,
		  		oldPass:'',
		  		newPass:'',
		  		comfirNewPass:'',
		  		code:"",
		  		ifwarn:false,
		  		warntxt:'',
		  	}
		},
		methods:{
			
			registerNew(){
				if(this.newPass!=this.comfirNewPass){
					this.ifwarn = true;
	        		this.warntxt = '确认新密码要和新密码一致';
				}
				else if(this.oldPass!='' && this.newPass!=''){
					this.innerUpPass = false;
					let setNewPassParams={
			  			new_psd:sha256(this.newPass),
			  			old_psd:sha256(this.oldPass),
			  			username:this.getCookie('username'),
			  			uid:this.getCookie('uid'),
			  			timestamp:Date.parse( new Date()),
			  		    terminalId:4
			  		};
			  		this.sign(setNewPassParams);
			  		this.$ajax.post(this.$store.state.domain+"/Home/EditPsd/EditPsd",this.$qs.stringify(setNewPassParams),{
			            emulateJSON: true
			        }).then(res=>{
			        	if(res.data.status==1){
			        		//console.log("验证码发送成功");
			        		this.innerUpPassText = "密码重置成功，请重新登录";
							this.innerUpPass = true;
			        		
			        	}else if(res.data.code==10008){
			        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
			        	}else{
			        		//console.log(res.data.msg);
			        		this.ifwarn = true;
			        		this.warntxt = res.data.msg;
			        	}
			  		});
				}
				else{
					this.ifwarn = true;
					this.warntxt = '确认新密码要和新密码一致';
				}
				
			},
			closeDialog(){
				this.$router.push('/login');
			}
			
		}
	}
</script>

<style scoped>
	.login{
		min-height: 0;
		width: 415px;
		padding-bottom: 20px;
	}
	.log-bg{
		height: 0px;
	}
	.log-logo{
		margin-top: 20px;
		margin-bottom: 0px;
		height: 60px;
	}
</style>


// WEBPACK FOOTER //
// src/components/resetPass.vue